export class NecAlertData {
  /**
   * Alertæ é¢
   */
  title: string;

  /**
   * Alertæ­£æ
   */
  text: string;

  /**
   * ç¡®å®çåè°å½æ°
   */
  accept: Function;

  /**
   * åæ¶çåè°å½æ°
   */
  reject: Function;

  /**
   * ç¡®å®æé®çææ¬
   */
  acceptText?= 'ç¡®å®';

  /**
   * åæ¶æé®çææ¬
   */
  rejectText?= 'åæ¶';
}
